
const state = {
  login: null,
  needLogin: null,
  permission: null
}

const mutations = {
  setLoginError (state, error) {
    state.login = error
  },
  setNeedLoginError (state, error) {
    state.needLogin = error
  },
  setPermissionError (state, permission) {
    state.permission = permission
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
